"use client";

import { type MantineColorScheme, useMantineColorScheme } from "@mantine/core";
import { useEffect } from "react";
import { useSearchParams } from "react-router";

export function ColorModeForcer() {
	const { setColorScheme, colorScheme } = useMantineColorScheme();
	const [searchParams] = useSearchParams();
	const forceColorMode = searchParams.get("force-color-mode");
	const initialColorMode = searchParams.get("initial-color-mode");

	useEffect(() => {
		if (initialColorMode) {
			setColorScheme(initialColorMode as MantineColorScheme);
		}
	}, [initialColorMode]);

	useEffect(() => {
		if (
			(forceColorMode === "light" ||
				forceColorMode === "dark" ||
				forceColorMode === "system") &&
			forceColorMode !== colorScheme
		) {
			localStorage.setItem("original-mantine-color-scheme", colorScheme ?? "");
			setColorScheme(forceColorMode as MantineColorScheme);
		} else if (localStorage.getItem("original-mantine-color-scheme")) {
			setColorScheme(
				localStorage.getItem(
					"original-mantine-color-scheme",
				) as MantineColorScheme,
			);
			localStorage.removeItem("original-mantine-color-scheme");
		}
	}, [forceColorMode]);

	return null;
}
